const cmsConfig = {
  cmsPages: {
    rules_ru: 5,
    rules_en: 6,
    faq_ru: 7,
    faq_en: 8,
    about_ru: 9,
    about_en: 10,
    contacts_ru: 11,
    contacts_en: 12,
    bookingavia: 13,
    returnavia: 14,
    paymentavia: 15,
    getaviaticket: 16,
    airplanes: 17,
    tu134: 18,
    tu154: 19,
    tu204: 20,
    superjet100: 22,
    il62: 23,
    il86: 24,
    il96: 25,
    il96300: 26,
    il96m: 27,
    a310: 28,
    a320: 29,
    a330: 30,
    boeing737: 31,
    boeing747: 32,
    boeing767: 33,
    boeing777: 34,
    airportsmap: 35,
    eticketavia: 36,
    'kategirii-poezdov-i-vagonov': 37,
    elektronnaja_registracija: 38,
    'electronny-bilet-na-poezd': 39,
    usefuldata: 40,
    abroadinstruction: 41,
    transportationrues: 42,
    forbiddensubjects: 43,
    resolvedsubjects: 44,
    fitocontrol: 45,
    veterinarycontrol: 46,
    castomscontrol: 47,
    declaringlist: 48,
    specialexportlist: 49,
    boundarycontrol: 50,
    preflightcontrol: 51,
    serviceonboard: 52,
    aircompanies: 53,
    bookingzd: 54,
    'kak-oplatit-zhd-bilet': 55,
    poluchenie_proezdnyh_dokumentov: 56,
    'get-paper-ticket': 57,
    'pravila-vozvrata-zhd-biletov': 58,
    'zheldor-pravila': 59,
    oformlenie_detskih_biletov: 60,
    'proezd-v-vagonah-povyshennoj-komfortnosti': 61,
    osobennosti_oformlenija_zakaza: 62,
    pravila_okazaniya_uslug_na_zheleznodorozhnom_transporte: 63,
    'oformlenie-zhd-bileta': 64,
    insurance_oferta: 65,
    insurance_oferta_alfa: 66,
    offer_partners: 67,
    insurance_oferta_d2: 68,
    insurance_oferta_alfa_covid: 69,
    'covid-19': 70,
    confidentiality_ru: 71,
    confidentiality_en: 72,
    // insurance_d2_refund_oferta: 73,
    // insurance_d2_refund_rules: 74,
    gettsleep_terms_ru: 75,
    gettsleep_terms_en: 76,
    // rail_electronic_registration: 79,
    // rail_buy_electronic_ticket: 80,
    // rail_transport_rules: 81,
    // rail_tariff_info: 82,
    'poisk-populjarnyh-marshrutov': 85,
    guide: 86,
    guide_azerbaijan: 87,
    guide_armenia: 88,
    guide_vietnam: 89,
    'guide_hong-kong': 90,
    guide_georgia: 91,
    guide_israel: 92,
    guide_india: 93,
    guide_indonesia: 94,
    guide_yemen: 95,
    guide_kazakhstan: 96,
    guide_cambodia: 97,
    guide_kyrgyzstan: 98,
    guide_china: 99,
    guide_malaysia: 100,
    guide_maldives: 101,
    guide_oman: 102,
    guide_singapore: 103,
    guide_tajikistan: 104,
    guide_thailand: 105,
    guide_turkey: 106,
    guide_uzbekistan: 107,
    guide_philippines: 108,
    'guide_sri-lanka': 109,
    guide_japan: 110,
    guide_austria: 111,
    guide_belarus: 112,
    guide_belgium: 113,
    guide_bulgaria: 114,
    guide_germany: 115,
    guide_greece: 116,
    guide_ireland: 117,
    guide_spain: 118,
    guide_italy: 119,
    guide_cyprus: 120,
    guide_latvia: 121,
    guide_lithuania: 122,
    guide_malta: 123,
    guide_norway: 124,
    guide_portugal: 125,
    guide_russia: 126,
    guide_romania: 127,
    guide_serbia: 128,
    guide_slovenia: 129,
    guide_ukraine: 130,
    guide_finland: 131,
    guide_france: 132,
    guide_croatia: 133,
    guide_montenegro: 134,
    guide_switzerland: 135,
    guide_sweden: 136,
    guide_egypt: 137,
    guide_mauritius: 138,
    guide_madagascar: 139,
    guide_morocco: 140,
    guide_seychelles: 141,
    guide_tunisia: 142,
    guide_australia: 143,
    'guide_new-zealand': 144,
    guide_fiji: 145,
    guide_barbados: 146,
    guide_canada: 147,
    guide_cuba: 148,
    guide_mexico: 149,
    guide_jamaica: 150,
    guide_argentina: 151,
    guide_brazil: 152,
    guide_venezuela: 153,
    guide_peru: 154,
    'poisk-zhd-bileta': 155,
    regions: 156,
    cashback_promo: 157
  }
};
export default cmsConfig;
